import { render } from "./SetPhotoLimitation.vue?vue&type=template&id=e70e549c&scoped=true"
import script from "./SetPhotoLimitation.vue?vue&type=script&lang=js"
export * from "./SetPhotoLimitation.vue?vue&type=script&lang=js"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e70e549c"]])

export default __exports__